export const MuiMenuItem = {
  styleOverrides: {
    root: {
      '&:hover': {
        backgroundColor: '#1a3746',
      },
    },
  },
}
